import cn from "classnames"
import React from "react"
import "./FormSectionLeftIndent.scss"

interface IFormSectionLeftIndentProps {
    children?: React.ReactNode
    fullWidth?: boolean
}

export const FormSectionLeftIndent = ({ children, fullWidth }: IFormSectionLeftIndentProps) => {
    return <div className={cn("form-section-left-indent", fullWidth && "form-section-left-indent--full")}>{children}</div>
}
